import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody } from 'reactstrap'
import classNames from "classnames";
import BrandedIcon from '../../BrandingWhiteLabel/BrandedIcon';
import { getTranslation } from '../../../components/Global/helpers';

const InvalidCoverageError = ({ styles, accountName, languageCode , clientId}) => {
  const [brandPhoneContent, setBrandPhoneContent] = useState(null)

  useEffect(() => {
    const getBrandPhones = async () => {
      const brandPhoneContent = await getTranslation("COC/BrandProvider/BrandPhones.json").then(
        (response) => response.json(),
      );
      setBrandPhoneContent(brandPhoneContent);
    };
    getBrandPhones();
  }, []);
 
  return (
    <Container className="contentWrapper">
        <Card>
            <CardBody className={classNames(styles.processingCert, "m-5")}>
              <BrandedIcon accountName={accountName} iconType={'error'} />
              <h1 className="h3 pt-5">{"Our system is unable to process your request."}</h1>
              <p className="text-center">
                {`If issues persist contact Customer Support at ${brandPhoneContent?.[clientId]}`}
              </p> 
            </CardBody>
        </Card>
    </Container>
  )
}

export default InvalidCoverageError;